import { useMutation, useQueryClient } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useCreateUser = (options = {}) => {
  const queryClient = useQueryClient();
  const prefix = process.env.REACT_APP_PUBLIC_PREFIX || '';
  return useMutation({
    mutationFn: async (userData) => {
      const response = await restClient({
        url: `${prefix}/public/auth/register`,
        method: 'POST',
        data: userData
      });
      return response;
    },
    onSuccess: (data, variables, context) => {
      // Invalidate users list to refresh data
      queryClient.invalidateQueries({ queryKey: ['users'] });
      queryClient.invalidateQueries({ queryKey: ['userGroups'] });
      
      // Call custom onSuccess if provided
      if (options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      console.error('Error creating user:', error);
      
      // Call custom onError if provided
      if (options.onError) {
        options.onError(error, variables, context);
      }
    },
    ...options
  });
};
